import { client } from './client'
import Place from '../models/place'

export default {
  index (query) {
    return client.get('/places', {
      params: query
    })
  },
  show (id) {
    return client.get('/places/' + id)
      .then((response) => {
        return new Place(response.data.data)
      })
  },
  store (data) {
    return client.post('/places', data.prepareForSend())
  },
  update (id, data) {
    return client.patch('/places/' + id, data.prepareForSend())
  },
  search (data, query) {
    return client.get('/places', {
      params: {
        filter: JSON.stringify(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    })
  },
  select (data) {
    let place = new Place()
    place.nome = data
    return client.get('/places', {
      params: {
        filter: JSON.stringify(place),
        limit: 100,
        orderBy: 'nome'
      }
    })
  },
  delete (id) {
    return client.delete('/places/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/places.js